module.exports = __webpack_public_path__ + "media/ru_ru_s4_Olga.0b206770.mp3";